@if (chartHistory$ | async; as chartHistory) {
  @if (chartHistory.length) {
    <div class="flex items-center gap-4">
      <pr-charting-history-selector
        label="Compare with chart"
        [allowEmpty]="true"
        [chartHistory]="chartHistory"
        (selectedChange)="selectedChartChange.emit($event)"
      />

      <mat-form-field subscriptSizing="dynamic" class="max-w-[160px]">
        <mat-label>Compare Mode</mat-label>
        <mat-select [formControl]="compareModeCtrl">
          @for (mode of compareMode; track $index) {
            <mat-option [value]="mode">
              {{ mode | titlecase }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
}
